import { object, string, boolean, collection } from '@gogame/schemas';

import {
  CHART_VIEW_SETTINGS_BRUSH,
  CHART_VIEW_SETTINGS_LEGEND,
  CHART_VIEW_SETTINGS_PERCENTAGE,
  CHART_VIEW_SETTINGS_STACKED,
  CHART_VIEW_SETTINGS_TYPE,
  CHART_VIEW_SETTINGS_FULL_NAME,
  CHART_VIEW_SETTINGS_PIE_LABEL_TYPE,
  CHART_VIEW_SETTINGS_LABEL,
  CHART_BREAKDOWN_METRIC_TYPES,
  CHART_METRIC_MIXED_TYPES,
} from './constants';

const metricMixedTypeSchema = object(
  {
    id: string(),
    label: boolean(),
    type: string(),
  },
  'metric'
);

const breakdownMixedTypeSchema = object(
  {
    type: string(),
  },
  'breakdown'
);

export const viewSettingsSchema = object({
  [CHART_VIEW_SETTINGS_TYPE]: string().default('line'),
  [CHART_VIEW_SETTINGS_BRUSH]: boolean().default(false),
  [CHART_VIEW_SETTINGS_LEGEND]: boolean().default(false),
  [CHART_VIEW_SETTINGS_PERCENTAGE]: boolean().default(false),
  [CHART_VIEW_SETTINGS_STACKED]: boolean(),
  [CHART_VIEW_SETTINGS_FULL_NAME]: boolean(),
  [CHART_VIEW_SETTINGS_PIE_LABEL_TYPE]: string().default('value'),
  [CHART_VIEW_SETTINGS_LABEL]: boolean().default(false),
  [CHART_METRIC_MIXED_TYPES]: collection(metricMixedTypeSchema)
    .encodeSeparator('~~')
    .default([]),
  [CHART_BREAKDOWN_METRIC_TYPES]: collection(breakdownMixedTypeSchema)
    .default([])
    .encodeSeparator('~~'),
});

// TODO: remove defaultChartViewSettings import  from screen schemas
export const defaultChartViewSettings = viewSettingsSchema.default();
